import React, { useContext } from 'react';
import { REQUEST_BIB_RECORD } from './query';
// STYLE
import Button from '@material-ui/core/Button';
import { gql, useMutation, useQuery, useReactiveVar } from '@apollo/client';
import { userInfoVar } from '../../../../../../apollo/localState/userInfoVar';
import { ME_QUERY_V2 } from '../../../../../../apollo/queries/searchRelatedQueries';
import { useFetchAllTransaction } from '../../../../../../hooks/useFetchAllTransaction';
import { MyTransactionContext } from '../../../../../../context/myTransactionContext';
import { CircularProgress } from '@material-ui/core';
import CancelRequestButton from '../../../../../HoldingsTable/HoldingsTableOperationColumn/CancelRequestButton/CancelRequestButton';

const BIB_ITEMS = gql`
  query simpleSearchBibliographicsRecords_v2($bibId: String, $itemCount: Int) {
    simpleSearchBibliographicsRecords_v2(
      searchValue: $bibId
      searchType: "record-guid"
    ) {
      records {
        id
        _physicalManifestations(first: $itemCount) {
          guid
          hasActiveLoan
          hasReservation
          hasRequests
        }
      }
    }
  }
`;

const ItemsTableTogglerRequestBibButton = ({ bibData, me, setRequestData }) => {
  const { data, loading } = useContext(MyTransactionContext);

  const items =
    bibData?.simpleSearchBibliographicsRecords_v2?.records[0]
      ?._physicalManifestations ?? [];

  const { data: bibItemData, loading: bibItemsLoading } = useQuery(BIB_ITEMS, {
    variables: {
      bibId: bibData?.simpleSearchBibliographicsRecords_v2?.records[0]?.id,
      itemCount:
        bibData?.simpleSearchBibliographicsRecords_v2?.records[0]
          ?._physicalManifestations_count,
    },
    skip: !bibData,
  });

  const [requestBib, { loading: mutationLoading }] = useMutation(
    REQUEST_BIB_RECORD,
    {
      refetchQueries: [
        'searchBibItems',
        'fetchMyTransactions',
        'fetchMyTransactionsCount',
      ],
    }
  );

  const { isMemberCardActive } = useReactiveVar(userInfoVar);

  if (loading || bibItemsLoading) {
    return <CircularProgress color="primary" size={15} />;
  }

  const requestClickedHandler = () => {
    if (mutationLoading) return;

    requestBib({
      variables: {
        data: {
          targetBibRecord: {
            guid: bibData.simpleSearchBibliographicsRecords_v2.records[0].id,
          },
        },
      },
    }).then(res => {});
  };

  const isAny = ruleType => {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (
        item.calculatedItemPolicyForPatron?.rules?.find(
          rule => rule.ruleType === ruleType
        )?.ruleValue === 'true'
      ) {
        return true;
      }
    }

    return false;
  };

  const isBorrowable = isAny('IS_BORROWABLE');
  const isRequestable = isAny('IS_BOOKABLE');

  if (!isBorrowable || !isRequestable) {
    return null;
  }

  const requestByUser = data?.myActiveRequests?.find(request => {
    return (
      request?.bibliographicRecord?.guid ===
        bibData?.simpleSearchBibliographicsRecords_v2?.records[0]?.id ||
      request?.item?.physicalManifestationOf?.guid ===
        bibData?.simpleSearchBibliographicsRecords_v2?.records[0]?.id
    );
  });

  if (requestByUser) {
    return (
      <>
        <Button
          color="primary"
          onClick={() => setRequestData(requestByUser)}
          variant="outlined"
          size="small"
          style={{ marginRight: '5px' }}
        >
          Előjegyzésem megtekintése
        </Button>
        <CancelRequestButton guid={requestByUser?.id} />
      </>
    );
  }

  const bibItems =
    bibItemData?.simpleSearchBibliographicsRecords_v2?.records?.[0]
      ?._physicalManifestations || [];

  const hasReservationByUser = (
    data?.myActiveReservations || []
  )?.some(reservation =>
    bibItems.some(item => reservation.targetItem?.guid === item?.guid)
  );
  const hasLoanByUser = (data?.myActiveLoans || [])?.some(loan =>
    bibItems.some(item => loan.item?.guid === item?.guid)
  );

  if (hasReservationByUser || hasLoanByUser) {
    return null;
  }

  const loanedItemLength = bibItems?.filter(item => item.hasActiveLoan)?.length;
  const reservedItemLength = bibItems?.filter(item => item.hasReservation)
    ?.length;
  const isRequestButtonDisplay =
    loanedItemLength + reservedItemLength === bibItems?.length;

  if (isRequestButtonDisplay) {
    return (
      <Button
        color="primary"
        onClick={requestClickedHandler}
        variant="outlined"
        size="small"
        disabled={!isMemberCardActive || mutationLoading}
      >
        Előjegyzés
      </Button>
    );
  } else {
    return null;
  }
};

export default ItemsTableTogglerRequestBibButton;
